import React, { useEffect, useState } from 'react'
import { PlanDataset } from '../components/PlanDataset'
interface Props {
    selected: {
        asset: {
            id: string
            name: string
        }
    }
}

export const WellPanTabContent = ({ selected, ...props }: Props) => {
    return (
        <div className="flex-column">
            <PlanDataset selected={selected} />
        </div>
    )
}
